<template>
  <div class="proposal-sign-wrap">
    <page-status class="proposal-sign" :loading="loading" v-if="!SignFlag">
      <van-cell-group>
        <van-cell>
          <cell-header slot="title" title="基本信息" />
        </van-cell>
        <van-cell title="车牌号" :value="detail.licenseNo || '新车未上牌'" />
        <van-cell title="车架号" :value="detail.frameNo" />
        <van-cell title="投保人" :value="detail.appliName" />
        <van-cell
          title="驾乘总保费"
          v-if="onlyShowJcFrame === '1'"
          :value="`${jcTotalPremium}元`"
        />
        <van-cell title="总保费" v-else :value="`${detail.totalPremium}元`" />
      </van-cell-group>

      <van-cell-group style="margin-top: 12px">
        <van-cell>
          <cell-header slot="title" title="条款信息" />
        </van-cell>
        <van-cell
          v-for="(clause, index) in detail.clauseVos"
          :key="index"
          @click="onViewClause(index)"
          is-link
        >
          <span :class="{ clause: true, active: clause.clicked }" slot="title">
            {{ `${index + 1}、${clause.clauseName}` }}
          </span>
        </van-cell>
      </van-cell-group>

      <div class="agreement">
        <van-checkbox v-model="checked">
          保险人已明确说明条款内容，免除保险人责任条款的含义及其法律后果
        </van-checkbox>
      </div>

      <van-cell-group>
        <van-cell>
          <cell-header slot="title" title="投保人签名" />
        </van-cell>
        <div class="sign-container">
          <div class="sign-content">
            <vue-signature-pad width="100%" height="240px" ref="signaturePad" />
          </div>
          <div class="sign-actions">
            <van-button
              class="button"
              type="default"
              @click="onClearSignature()"
            >
              重新签名
            </van-button>
            <van-button
              class="button"
              type="info"
              @click="onConfirmSignature()"
            >
              确认投保
            </van-button>
          </div>
        </div>
      </van-cell-group>
      <page-footer />

      <van-dialog v-model="showDialog" title="提示">
        <div class="dialog-content" v-if="unreadItem">
          {{ `请先点击打开阅读《${unreadItem.clauseName}》` }}
        </div>
      </van-dialog>

      <van-popup
        :close-on-click-overlay="false"
        v-model="showClause"
        position="bottom"
        :style="{ height: '80%' }"
      >
        <div class="viewer-content">
          <pdf-viewer :url="clauseUrl" />
        </div>
        <div class="viewer-footer">
          <van-button
            class="button"
            type="info"
            @click="closeClause()"
            :disabled="isClick"
          >
            {{ isClick ? `请您仔细阅读以上信息${time}秒` : `关闭` }}
          </van-button>
        </div>
      </van-popup>
    </page-status>
    <page-result v-else :image="image" :title="title" :showHotline="false">
      <div class="btn" @click="toNextPage()">去支付</div>
    </page-result>
  </div>
</template>

<script>
import { Toast } from 'vant';
import VueSignaturePad from 'vue-signature-pad';
import PageStatus from '@/components/PageStatus';
import PageResult from '@/components/PageResult';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import PdfViewer from '@/components/PdfViewer';
import * as services from '@/services';
import * as cache from '@/utils/cache';
import imgSuccess from '@/assets/img-status-success.png';

export default {
  name: 'ProposalSignAnt',
  components: {
    VueSignaturePad,
    PageStatus,
    CellHeader,
    PageFooter,
    PdfViewer,
    PageResult,
  },

  data() {
    return {
      detail: {
        appliName: '',
        insuredName: '',
        biProposalNo: '',
        ciProposalNo: '',
        licenseNo: '',
        frameNo: '',
        totalPremium: '',
        payStatus: '',
        clauseVos: [],
      },
      loading: true,
      checked: false,
      showDialog: false,
      showClause: false,
      clauseUrl: '',
      SignFlag: false,
      image: imgSuccess,
      title: '投保单已签署成功',
      time: 0,
      isClick: true,
    };
  },

  computed: {
    unreadItem() {
      return this.detail.clauseVos.find(item => !item.clicked);
    },
  },

  watch: {
    checked(newValue) {
      if (this.unreadItem && newValue) {
        this.showDialog = true;
        this.checked = false;
      }
    },
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },

  activated() {
    this.$refs.signaturePad && this.$refs.signaturePad.resizeCanvas();
  },

  methods: {
    fetchData() {
      const { businessNo, mobile } = this.$route.query;
      const proposalAuth = cache.removeItem('ProposalAuth');
      if (this.checkSameProposal(proposalAuth, businessNo, mobile)) {
        this.getProposalSuccess(proposalAuth);
        return;
      }

      services
        .getMotorProposal(businessNo, mobile)
        .then(res => this.getProposalSuccess(res));
    },

    getProposalSuccess(res) {
      this.detail = res.data.policyInfo;
      this.loading = false;
    },

    checkSameProposal(proposalAuth, businessNo, mobile) {
      return (
        proposalAuth &&
        proposalAuth.businessNo === businessNo &&
        proposalAuth.mobile === mobile
      );
    },

    onViewClause(index) {
      const { mobile } = this.$route.query;
      const clause = this.detail.clauseVos[index];
      this.$set(this.detail.clauseVos, index, { ...clause, clicked: true });
      this.showClause = true;
      this.isClick = true;
      this.time = 5;
      this.countdown();
      this.clauseUrl = services.getMotorProposalLink(clause, mobile);
    },

    countdown() {
      const timer = setInterval(() => {
        if (this.time !== 0) {
          this.time -= 1;
        } else {
          this.isClick = false;
          clearInterval(timer);
        }
      }, 1000);
    },

    onClearSignature() {
      this.$refs.signaturePad.clearSignature();
    },

    onConfirmSignature() {
      if (!this.checked) {
        Toast({ message: '请确认勾选已阅读并接受以上条款信息' });
        return;
      }

      const signaturePad = this.$refs.signaturePad;
      const { isEmpty, data } = signaturePad.saveSignature();

      if (isEmpty) {
        Toast({ message: '请签名' });
        return;
      }

      Toast.loading({
        message: '正在上传签名',
        forbidClick: true,
        duration: 0,
      });

      const { query } = this.$route;
      const { businessNo, mobile } = query;
      const file = this.dataURLtoFile(data);

      services
        .signMotorProposal(businessNo, mobile, data, file)
        .then(({ data }) => this.signProposalSuccess(data, businessNo));
    },

    signProposalSuccess(data) {
      this.SignFlag = true;
      setTimeout(() => {
        this.toNextPage(data);
      }, 3000);
      Toast.clear();
    },

    toNextPage(data) {
      const { antUrl } = data;
      if (antUrl) {
        window.location.replace(antUrl);
      } else {
        this.detail = { ...this.detail, clauseVos: [] };
        this.fetchData();
        this.checked = false;
        this.SignFlag = false;
      }
    },

    dataURLtoFile(dataURL) {
      const parts = dataURL.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; i++) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      const filename = `${Date.now()}.png`;
      const blob = new Blob([uInt8Array], { type: contentType });
      return new File([blob], filename, { type: contentType });
    },
  },
};
</script>

<style lang="less">
.proposal-sign-wrap {
  .proposal-sign {
    width: 100%;
    height: 100%;
    padding-top: 12px;
    box-sizing: border-box;

    .clause.active {
      color: #108ee9;
    }

    .agreement {
      padding: 12px;
      font-size: 14px;
    }

    .sign-container {
      padding: 12px;
    }

    .sign-content {
      background-color: #fafafa;
      border: 1px solid #dcdcdc;
      border-radius: 4px;
    }

    .sign-actions {
      margin-top: 12px;
      text-align: center;
      display: flex;

      .button {
        flex: 1;
        border-radius: 4px;

        & + .button {
          margin-left: 12px;
        }
      }
    }

    .dialog-content {
      padding: 12px 24px;
      font-size: 14px;
      color: #030303;
      text-align: center;
    }

    .viewer-content {
      height: 100%;
      overflow: auto;
      background-color: #f9f9f9;
    }
    .viewer-footer {
      position: fixed;
      bottom: 0;
      height: 60px;
      width: 100%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        width: 100%;
      }
    }
  }
  .page-result {
    background-color: #ffffff;
    height: 100vh;
    .btn {
      width: 160px;
      height: 44px;
      line-height: 44px;
      border-radius: 4px;
      border: solid 1px #1665d8;
      text-align: center;
      color: #1665d8;
      font-size: 18px;
      margin: 0 auto;
    }
  }
}
</style>
